import React from 'react';
import { /* Link, */ withRouter } from 'react-router-dom';
import _ from 'lodash';
import { IProps, IState } from 'components/ProgramBlock/types';
import apiCommonService from 'bff/services/commonService';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import sweetAlertService from 'utils/sweetAlertService';
import { RouterSettings } from 'constants/models/routerSettings';
import { PlanType } from 'constants/enums/travelPlanType.enum';
import commonService from 'utils/commonService';
import { InsType } from 'constants/enums/insType.enum';

class ProgramBlock extends React.Component<IProps, IState> {
  static defaultProps = {
    favoriteBtn: true
  };

  private detailSlideRef = React.createRef() as React.RefObject<HTMLDivElement>;
  private detailSlideUlRef = React.createRef() as React.RefObject<HTMLUListElement>;
  private detailSlideHeight: number = 0;
  private detailSlideIndexLimit: number = 0;

  readonly state: IState = {
    detailSlide: {
      index: 0,
      prevBtnVisible: false,
      nextBtnVisible: false
    }
  }

  componentDidMount () {
    this.initDetailSlide();
  }

  componentDidUpdate (prevProps: IProps) {
    (prevProps.content !== this.props.content) && this.initDetailSlide();
  }

  /**
   * @description 收藏按鈕(愛心)狀態切換
   */
  handleFavoriteStatusToggle = (insTypeId:string, planId:string, prodId:string) => {
    const isLogin = storageService.getItem(storageKeys.LoginInfo);

    if (!isLogin) {
      sweetAlertService.modal({
        html: 'Hi~請問是否登入會員，以確保下次登入時還能看到收藏的內容唷！',
        showCancelButton: true,
        showCloseButton: true
      }).then((response) => {
        if (response.value) {
          this.props.unloginAddItem && this.props.unloginAddItem();

          this.props.history.push(RouterSettings.Login);
        }
      });

      return;
    }

    if (this.props.active) {
      sweetAlertService.modal({
        html: 'Hi~您確定要取消收藏嗎？',
        showCancelButton: true,
        showCloseButton: true
      }).then((response) => {
        if (response.value) {
          this.props.onRemoveItem && this.props.onRemoveItem();
        }
      });
    } else {
      this.props.onAddItem && this.props.onAddItem();
    }
  };

  /**
   * @description 初始 Detail Slide
   */
  initDetailSlide = () => {
    // if (this.detailSlideUlRef && this.detailSlideUlRef.current) {
    //   // 取得 Detail Slide element 高度
    //   this.detailSlideHeight = this.detailSlideRef.current!.clientHeight;
    //   // 取得 Detail Slide 總頁數 index
    //   this.detailSlideIndexLimit = Math.ceil(this.detailSlideRef.current!.clientHeight / this.detailSlideHeight) - 1;
    //   // 初始 Detail Slide 位置 (設置 position top 為 0px)
    //   this.detailSlideUlRef.current!.style.top = '0px';
    // }

    setTimeout(() => {
      // 取得 Detail Slide element 高度
      this.detailSlideHeight = this.detailSlideRef.current!.clientHeight;
      // 取得 Detail Slide 總頁數 index
      this.detailSlideIndexLimit = Math.ceil(this.detailSlideUlRef.current!.clientHeight / this.detailSlideHeight) - 1;
      // 初始 Detail Slide 位置 (設置 position top 為 0px)
      this.detailSlideUlRef.current!.style.top = '0px';

      // 初始 Detail Slide 的 State
      this.setState(state => ({
        ...state,
        detailSlide: {
          ...state.detailSlide,
          index: 0,
          prevBtnVisible: false,
          nextBtnVisible: this.detailSlideIndexLimit > 0 // 判斷如果頁數大於 1 頁，則顯示 Next Button
        }
      }));
    }, 1);
  }

  /**
   * @description Detail Slide 切換上一頁
   */
  handleDetailSlidePrev = () => {
    let activeIndex = this.state.detailSlide.index;

    activeIndex--;

    if (activeIndex < 0) {
      activeIndex = this.detailSlideIndexLimit;
    }

    this.setState(state => ({ ...state, detailSlide: { ...state.detailSlide, index: activeIndex } }));
    this.setDetailSlideBtnVisible(activeIndex);
    this.setDetailSlidePosition(activeIndex);
  }

  /**
   * @description Detail Slide 切換下一頁
   */
  handleDetailSlideNext = () => {
    let activeIndex = this.state.detailSlide.index;

    activeIndex++;

    if (activeIndex > this.detailSlideIndexLimit) {
      activeIndex = 0;
    }

    this.setState(state => ({ ...state, detailSlide: { ...state.detailSlide, index: activeIndex } }));
    this.setDetailSlideBtnVisible(activeIndex);
    this.setDetailSlidePosition(activeIndex);
  }

  /**
   * @description 設置 Detail Slide 滑動位置
   * @param activeIndex 當前頁 index
   */
  setDetailSlidePosition = (activeIndex: number) => {
    const offset = -(this.detailSlideHeight * activeIndex);
    this.detailSlideUlRef.current!.style.top = offset + 'px';
  }

  /**
   * @description 設置 Detail Slide 按鈕可見度
   * @param activeIndex 當前頁 index
   */
  setDetailSlideBtnVisible = (activeIndex: number) => {
    const prevBtnVisible = (activeIndex > 0 && activeIndex <= this.detailSlideIndexLimit);
    const nextBtnVisible = (activeIndex >= 0 && activeIndex < this.detailSlideIndexLimit);
    this.setState(state => ({
      ...state,
      detailSlide: {
        ...state.detailSlide,
        prevBtnVisible: prevBtnVisible,
        nextBtnVisible: nextBtnVisible
      }
    }));
  }

  /**
   * @description 處理費用高亮 (費用標示為紅色)
   * @param str 要處理的字串
   * @param index 作為 key 值的 index
   */
  handleFeeHighlight = (str: string, index: number, insTypeId: InsType) => {
    // 取得字串第一個數字的 index
    const searchResult = str.search(/\d/);
    const firstNumIndex = (searchResult >= 0) ? searchResult : 0;
    // 利用數字 index 分割字串
    return (
      <p key={index} className={insTypeId === InsType.Pet ? 'color-main' : ''}>
        {str.substring(0, firstNumIndex)}
        <span>{str.substring(firstNumIndex)}</span>
      </p>
    );
  }

  /**
   * @description 渲染 Detail
   * @param items 內容資料
   */
  renderDetail = (items: any, insTypeId: InsType) => {
    if (!items) return new Array(0);
    return _.map(items, (item: any, index: number) => {
      return (item.TYPE === 'HEAD' && this.renderDetailHeader(item.TEXT, index, insTypeId)) ||
          (item.TYPE === 'BODY' && this.renderDetailBody(item.TEXT, index, insTypeId)) ||
          (item.TYPE === 'FEE' && this.renderDetailFee(item.TEXT, index, insTypeId));
    });
  }

  /**
   * @description 渲染 Detail Header
   * @param headData 內容資料
   * @param index 作為 key 值的 index
   */
  renderDetailHeader = (headData: Array<string[]>, index: number, insTypeId: InsType) => {
    return (
      <div className="program-block__detail-head" key={index}>
        <ul>
          {_.map(headData, (row: string[], rowIndex: number) => (
            <li key={rowIndex}>
              {_.map(row, (text: string, textIndex: number) => (
                ((textIndex === 0 && text) && <p key={textIndex}>{text}</p>) ||
                ((textIndex === 1 && text) && this.handleFeeHighlight(text, textIndex, insTypeId))
              ))}
            </li>
          ))}
        </ul>
      </div>
    );
  }

  /**
   * @description 渲染 Detail Body
   * @param bodyData 內容資料
   * @param index 作為 key 值的 index
   */
  renderDetailBody = (bodyData: Array<string[]>, index: number, insTypeId: InsType) => {
    const { detailSlide } = this.state;
    const slidePrevBtnClasses = ['program-block__detail-slide-prev-btn'];
    const slideNextBtnClasses = ['program-block__detail-slide-next-btn'];

    if (!detailSlide.prevBtnVisible) slidePrevBtnClasses.push('program-block__detail-slide-prev-btn--hidden');
    if (!detailSlide.nextBtnVisible) slideNextBtnClasses.push('program-block__detail-slide-next-btn--hidden');

    return (
      <div className="program-block__detail-slide" key={index}>
        <button type="button" className={slidePrevBtnClasses.join(' ')} onClick={this.handleDetailSlidePrev} />
        <div className="program-block__detail-slide-container" ref={this.detailSlideRef}>
          <ul ref={this.detailSlideUlRef}>
            {_.map(bodyData, (row: string[], rowIndex: number) => (
              <li key={rowIndex}>
                {_.map(row, (text: string, textIndex: number) => (
                  ((textIndex === 0 && text) && <p key={textIndex}>{text}</p>) ||
                  ((textIndex === 1 && text) && this.handleFeeHighlight(text, textIndex, insTypeId))
                ))}
              </li>
            ))}
          </ul>
        </div>
        <button type="button" className={slideNextBtnClasses.join(' ')} onClick={this.handleDetailSlideNext} />
      </div>
    );
  }

  /**
   * @description 渲染 Detail Fee
   * @param feeData 內容資料
   * @param index 作為 key 值的 index
   */
  renderDetailFee = (feeData: Array<string[]>, index: number, insTypeId: InsType) => {
    return (
      <div className="program-block__detail-fee" key={index}>
        <ul>
          {_.map(feeData, (row: string[], rowIndex: number) => (
            <li key={rowIndex}>
              {_.map(row, (text: string, textIndex: number) => (
                ((textIndex === 0 && text) && (
                  <p key={textIndex}>
                    {text.substring(0, text.length - 1)}
                    {
                      /[\u4e00-\u9fa5]/.test(text.substring(text.length - 1))
                        ? <span>{text.substring(text.length - 1)}</span>
                        : <span className="symbol">{text.substring(text.length - 1)}</span>
                    }
                  </p>
                )) ||
                ((textIndex === 1 && text) && this.handleFeeHighlight(text, textIndex, insTypeId))
              ))}
            </li>
          ))}
        </ul>
      </div>
    );
  }

  /**
   * @description 處理「執行/投保/續保」按鈕執行的事件
   */
  handleRedirect = async (url: string, content: any, programId?: string) => {
    let _programId = '';
    // 如有填入專案代碼，判斷專案代碼是否存在
    if (programId) {
      const res = await apiCommonService.verifyProgramId(programId, content.INS_TYPE_ID);
      if (res && res.PROGRAM_ID) {
        _programId = res.PROGRAM_ID;
      }
    }
    commonService.setActiveProdId(content.INS_TYPE_ID === InsType.ECar ? InsType.Car : content.INS_TYPE_ID, content.PROD_ID, _programId);
    this.props.history.push({
      pathname: `${process.env.REACT_APP_PREFIX}${url.replace(/^.*(\/insure-process)||(\/insure-process\/travel)||(\/insure-process\/car)||(\/insure-process\/moto)$/, '$1')}`,
      state: {
        insTypeId: content.INS_TYPE_ID,
        prodId: content.PROD_ID,
        planId: content.PLAN_ID,
        programId: _programId
      }
    });
  }

  render () {
    const { content, active, favoriteBtn, programId } = this.props;
    const programBlockClasses = ['program-block'];
    const favioriteClasses = ['program-block__favorite-btn'];

    if (active) programBlockClasses.push('program-block--active');

    if (content.PLAN_ID === PlanType.Free) favioriteClasses.push('visibility-hidden');

    const applyUrl = content.APPLY_URL
      ? content.APPLY_URL
      : content.CONTENT && content.CONTENT.APPLY_URL
        ? content.CONTENT.APPLY_URL
        : RouterSettings.Home;

    const brief = content.BRIEF
      ? content.BRIEF
      : content.CONTENT?.BRIEF
        ? content.CONTENT?.BRIEF
        : content.DESCTEXT
          ? content.DESCTEXT.join(',')
          : '';

    const contentItem = content.CONTENT_ITEM
      ? content.CONTENT_ITEM
      : content.CONTENT
        ? content.CONTENT?.CONTENT_ITEM
        : content.PROMO_CONTENT
          ? content.PROMO_CONTENT?.CONTENT_ITEM
          : new Array(0);

    return (
      <div className={programBlockClasses.join(' ')}>
        {content && (
          <>
            <div className="program-block__title">
              <span>{content.TITLE || content.CONTENT?.TITLE}</span>
              {(content.PROD_ID?.includes('APE') || content.PROD_ID?.includes('AME')) && <span>-電車版</span>}
              {favoriteBtn && (
                <button
                  type="button"
                  className={favioriteClasses.join(' ')}
                  onClick={() => this.handleFavoriteStatusToggle(content.INS_TYPE_ID, content.PLAN_ID, content.PROD_ID)}
                />
              )}
            </div>
            <div className="program-block__desc">
              <p>{brief}</p>
            </div>
            <div className="program-block__detail">
              {this.renderDetail(contentItem, content.INS_TYPE_ID)}
              {content.INS_TYPE_ID === InsType.Pet ? <div className="program-block__detail-info"><span>寵物年齡8歲以內，混種犬(貓)，已絕育，無賠款紀錄</span></div> : null}
            </div>
            {
              applyUrl.indexOf('/insure-process') !== -1 ? (
                // <Link
                //   to={() => {
                //     commonService.setActiveProdId(content.INS_TYPE_ID, content.PROD_ID, programId);
                //     return {
                //       pathname: `${process.env.REACT_APP_PREFIX}${applyUrl.replace(/^.*(\/insure-process)||(\/insure-process\/travel)||(\/insure-process\/car)||(\/insure-process\/moto)$/, '$1')}`,
                //       state: {
                //         insTypeId: content.INS_TYPE_ID,
                //         prodId: content.PROD_ID,
                //         planId: content.PLAN_ID,
                //         programId: programId
                //       }
                //     };
                //   }}
                //   className="program-block__btn"
                // >
                //   {this.props.insTypeId === InsType.Travel ? '立即試算/投保' : '試算/投保/續保'}
                // </Link>
                <button style={{ width: '100%' }} className="program-block__btn" onClick={() => this.handleRedirect(applyUrl, content, programId)}>{this.props.insTypeId === InsType.Travel ? '立即試算/投保' : '試算/投保/續保'}</button>
              ) : (
                <a href={applyUrl} target="_blank" rel="noopener noreferrer" className="program-block__btn">
                  {this.props.insTypeId === InsType.Travel ? '立即試算/投保' : '試算/投保/續保'}
                </a>
              )
            }
          </>
        )}
      </div>
    );
  }
};

export default withRouter(ProgramBlock);
